import React, { useState, useEffect } from 'react';
import { Button, Modal, Input } from 'reactstrap';
import './Modal.css';
import { useForm } from 'react-hook-form';
import { doSignupOrg, getMunicipalities, cleanSignUpOrgError } from '../../store/actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { useTranslation } from 'react-i18next';

const ModalSignUp = ({ modal, toggle }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation([]);
  const language = useSelector((state) => state.language);
  const municipalities = useSelector(({ municipalities }) => municipalities?.municipalities);
  const signUpOrgResponse = useSelector(({ signup }) => signup);
  useEffect(() => {
    dispatch(cleanSignUpOrgError());
    dispatch(getMunicipalities({ pagination: false }));
  }, []);

  const onSubmit = (data) => {
    setIsLoading(true);
    dispatch(cleanSignUpOrgError());
    const { email, password, name, municipality } = data;
    dispatch(doSignupOrg(email, password, name, municipality, language || 'en'));
  };

  useEffect(() => {
    if (signUpOrgResponse) {
      setIsLoading(signUpOrgResponse.orgLoading === null ? false : signUpOrgResponse.orgLoading);
    }
  }, [signUpOrgResponse]);
  return (
    <Modal isOpen={modal} toggle={toggle} className={`${isLoading && 'standard whirl'}`}>
      <div style={{ justifyContent: 'center', marginTop: 40 }} className='text-center'>
        <span>{t('SignUpModal.spanTitle')}</span>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='row' style={{ justifyContent: 'center', marginTop: 40 }}>
          <div className='col-md-8' style={{ display: 'flex' }}>
            <div className='col-md-3'>
              <div
                className='modalInputTitle'
                style={{
                  border: errors.name ? 'solid 1px red' : 'none',
                }}
              >
                {t('SignUpModal.firstInputTitle')}
              </div>
            </div>
            <div className='col-md-9'>
              <div>
                <input
                  type='text'
                  className='form-control modalInput'
                  {...register('name', { required: true })}
                  style={{
                    border: errors.name ? 'solid 1px red' : 'solid 1px #A5A5A5',
                  }}
                />
              </div>
            </div>
          </div>
          <div className='col-md-8' style={{ display: 'flex' }}>
            <div className='col-md-3'>
              <div
                className='modalInputTitle'
                style={{
                  border: errors.email ? 'solid 1px red' : 'none',
                }}
              >
                {t('SignUpModal.secondInputTitle')}
              </div>
            </div>
            <div className='col-md-9'>
              <div>
                <input
                  type='email'
                  className='form-control modalInput'
                  {...register('email', {
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'email does not match',
                    },
                  })}
                  style={{
                    border: errors.email ? 'solid 1px red' : 'solid 1px #A5A5A5',
                  }}
                />
              </div>
            </div>
          </div>
          <div className='col-md-8' style={{ display: 'flex' }}>
            <div className='col-md-3'>
              <div
                className='modalInputTitle'
                style={{
                  border: errors.password ? 'solid 1px red' : 'none',
                }}
              >
                {t('SignUpModal.thirdInputTitle')}
              </div>
            </div>
            <div className='col-md-9'>
              <div>
                <input
                  type='password'
                  className='form-control modalInput'
                  {...register('password', { required: true })}
                  style={{
                    border: errors.password ? 'solid 1px red' : 'solid 1px #A5A5A5',
                  }}
                />
              </div>
            </div>
          </div>
          <div className='col-md-8' style={{ display: 'flex' }}>
            <div className='col-md-3'>
              <div
                className='modalInputTitle'
                style={{
                  border: errors.municipality ? 'solid 1px red' : 'none',
                }}
              >
                {t('SignUpModal.fourthInputTitle')}
              </div>
            </div>
            <div className='col-md-9'>
              <div>
                <select
                  className='form-select form-control modalInput'
                  style={{
                    fontSize: '15px',
                    height: '37.5px',
                    border: errors.municipality ? 'solid 1px red' : 'solid 1px #A5A5A5',
                  }}
                  aria-label='Default select example'
                  {...register('municipality', {
                    required: true,
                    validate: (value) => value !== 'choose',
                  })}
                >
                  <option selected value='choose'>
                    {t('SignUpModal.selectOption')}
                  </option>
                  {municipalities &&
                    municipalities.docs.map((municipality) => {
                      return (
                        <option value={municipality._id} key={municipality._id}>
                          {municipality.localisations[language].name}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
          </div>
          {signUpOrgResponse && signUpOrgResponse.orgError && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <p style={{ color: 'red' }}>{signUpOrgResponse.orgError}</p>
            </div>
          )}
          <div
            className='col-md-8'
            type='submit'
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: 40,
              marginTop: 20,
            }}
          >
            <Button
              color='primary'
              className='formBtn'
              style={{
                backgroundColor: '#fe9900',
                border: 0,
                borderRight: 10,
                padding: '8px 20px',
                marginRight: 5,
                borderRadius: 10,
                fontSize: 14,
              }}
            >
              Sign up
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ModalSignUp;
